import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperatorGroupBuilder } from '../../models/builders/operator-group.builder';
import { Operator } from '../../models/operator';
import { OperatorGroup } from '../../models/operator-group';
import { mapCollection } from '../../utils/collection.utils';

const groupBody = (group: OperatorGroup) => ({
  name: group.name,
  operatorHashes: mapCollection((operator: Operator) => operator.hash, group.operators || [])
});

@Injectable()
export class OperatorGroupApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }working-model-groups`;
  }

  getOperatorGroups(machineGroupHash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ machineGroupHash }/operator-groups`)
      .pipe(
        map(OperatorGroupBuilder.fromList)
      );
  }

  createOperatorGroup(machineGroupHash: string, group: OperatorGroup) {
    return this.httpClient.post(`${ this.apiUrl }/${ machineGroupHash }/operator-groups`, groupBody(group))
      .pipe(
        map(OperatorGroupBuilder.fromJson)
      );
  }

  updateOperatorGroup(machineGroupHash: string, group: OperatorGroup) {
    return this.httpClient.put(`${ this.apiUrl }/${ machineGroupHash }/operator-groups/${ group.hash }`, groupBody(group))
      .pipe(
        map(OperatorGroupBuilder.fromJson)
      );
  }

  deleteOperatorGroup(machineGroupHash: string, group: OperatorGroup) {
    return this.httpClient.delete(`${ this.apiUrl }/${ machineGroupHash }/operator-groups/${ group.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operator-group-api.service.ts